<section id="testimonials" class="section testimonials" aria-labelledby="testimonials-title">
  <div class="container">
    <header class="section-head testimonials__head" appReveal>
      <p class="eyebrow">Testimonials</p>
      <h2 id="testimonials-title" class="title">What our <em>customers</em> say</h2>
      <p class="lead">Reviews from Little Nap customers, just as they wrote them on littlenap.in.</p>
    </header>
  </div>

  <div class="wall" appReveal="120">
    @for (row of rows; track $index; let odd = $odd) {
      <div class="row" [class.row--back]="odd">
        <div class="row__track">
          @for (copy of copies; track copy) {
            <!-- (the second lap is only there for the eye) -->
            <ul class="row__lap" [attr.aria-hidden]="copy ? 'true' : null">
              @for (t of row; track t.name) {
                <li class="quote">
                  <span class="stars" aria-hidden="true">
                    @for (star of stars; track star) {
                      <svg viewBox="0 0 24 24" [class.is-on]="star <= t.stars"><path d="m12 2.6 2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.5l-5.9 3.1 1.2-6.5-4.8-4.6 6.6-.9z" /></svg>
                    }
                  </span>
                  <span class="sr-only">Rated {{ t.stars }} out of 5</span>
                  <blockquote class="quote__text">“{{ t.text }}”</blockquote>
                  <div class="quote__by">
                    <span class="quote__face" aria-hidden="true">{{ initials(t.name) }}</span>
                    <span class="quote__who">
                      <span class="quote__name">{{ t.name }}</span>
                      <span class="quote__meta">
                        <a [href]="t.href" target="_blank" rel="noopener" [attr.tabindex]="copy ? -1 : null">{{ t.product }}</a>
                        · {{ t.date }}
                      </span>
                    </span>
                  </div>
                </li>
              }
            </ul>
          }
        </div>
      </div>
    }
  </div>
</section>
